<script setup>
  import { computed } from 'vue';
  import ConfigurationRadioSelectionV2 from '../ConfigurationRadioSelectionV2';
  import ConfigurationCheckSelection from '../ConfigurationCheckSelection';
  import ConfigurationRadioSelection from '../ConfigurationRadioSelection';
  import { useMainStore } from '../../store/index.js';
  import '../../styles/configurator-section.css';
  import '../../styles/configurator-selection.css';

  const store = useMainStore();

  const emit = defineEmits(['select']);

  const props = defineProps({
    items: {
      type: Object,
      default: null,
    },
    images: {
      type: Object,
      default: null,
    },
  });

  const productOptions = computed(() => props.items.slice(0, 2) ?? []);
  const additionalOptions = computed(() => {
    const groupSize = 2;
    const options = [];
    if (props.items) props.items.slice(2).forEach((item) => options.push(item));
    return Array.from({ length: Math.ceil(options.length / groupSize) }, (_, i) => options.slice(i * groupSize, i * groupSize + groupSize));
  });
</script>

<template>
  <section
    v-if="props.items"
    id="interior"
    class="configurator-section"
  >
    <h2>{{ $i18n('interiorHeaderTitle') }}</h2>
    <div class="configurator-section__image">
      <img
        :src="props.images?.dashboard"
        alt="Truck - front side view"
      >
      <img
        :src="props.images?.interior"
        alt="Truck - front side view"
      >
    </div>
    <template
      v-for="productOption in productOptions"
      :key="productOption.id"
    >
      <h3>{{ $i18n(productOption.title) }}</h3>
      <ConfigurationRadioSelectionV2
        v-if="productOption.selectionType === 'radio'"
        v-model="store.selected.interior[productOption.id]"
        :type="productOption.id"
        :options="productOption.options"
        @select="emit('select', $event)"
      />
      <ConfigurationCheckSelection
        v-if="productOption.selectionType === 'checkbox'"
        v-model="store.selected.interior[productOption.id]"
        :type="productOption.id"
        :options="productOption.options"
        :inline-style="{ 'width': '30em' }"
        @select="emit('select', $event)"
      />
    </template>
    <template v-if="additionalOptions.length">
      <h3>{{ $i18n('additionalOptions') }}</h3>
      <template
        v-for="(packageGroup, index) in additionalOptions"
        :key="index"
      >
        <div class="configurator-section__row">
          <template
            v-for="(packageObject, index2) in packageGroup"
            :key="index2"
          >
            <div
              v-if="index2 > 0"
              class="sdds-divider-dark-vertical"
            />
            <ConfigurationRadioSelection
              v-if="packageObject.selectionType === 'radio'"
              v-model="store.selected.interior[packageObject.id]"
              :type="packageObject.id"
              :options="packageObject.options"
              :is-next-to-others="true"
              @select="emit('select', $event)"
            />
            <ConfigurationCheckSelection
              v-if="packageObject.selectionType === 'checkbox'"
              v-model="store.selected.interior[packageObject.id]"
              :type="packageObject.id"
              :options="packageObject.options"
              :inline-style="{ 'width': '30em' }"
              @select="emit('select', $event)"
            />
          </template>
        </div>
      </template>
    </template>
  </section>
</template>

<style scoped>
  .configurator-section__image {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 2em;
    max-width: 100%;
  }
  .configurator-section__image img {
    width: 40%;
  }
  .sdds-divider-dark-vertical {
    height: var(--sdds-spacing-layout-128);
    align-self: center;
  }
  .configurator-selection__checkoption {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 30em;
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 1000px) {
    .configurator-section__image {
      gap: 1em;
      max-width: 90%;
    }
    .sdds-divider-dark-vertical {
      display: none;
    }
    .configurator-section__row {
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 500px) {
    .configurator-section__image {
      flex-direction: column;
      align-items: center;
    }
    .configurator-section__image img {
      width: 90%;
    }
  }
</style>
